import styled from 'styled-components'

import * as ds from '@bob/design-system'

import { NewsletterForm } from '@bob/newsletter-form'

export function SecondaryNewsletterSection() {
  return (
    <Main>
      <Newsletter>
        <ds.styles.heading.Title3>Je m’abonne 👇</ds.styles.heading.Title3>
        <NewsletterForm />
        <ds.styles.copy.Text1>
          Bien ou Bien ne vendra pas votre adresse, et vous pourrez arrêter votre abonnement quand vous voulez.{' '}
          <strong>
            Aussi, vous recevrez un petit cadeau à l&apos;inscription : un e-book anti-greenwashing&nbsp;!
          </strong>
        </ds.styles.copy.Text1>
      </Newsletter>
    </Main>
  )
}

export const Newsletter = styled.div`
  max-width: 624px;

  background-color: ${ds.color.SAND_2};
  border-radius: 12px;
  padding: 20px;
  margin: 50px auto;

  ${ds.styles.heading.Title3} {
    margin-bottom: 20px;
  }

  ${ds.styles.copy.Text1} {
    margin-top: 20px;
    opacity: 0.75;
  }

  ${NewsletterForm} {
    display: flex;
    flex-direction: column;

    ${ds.Input} {
      flex: 2;
      margin-bottom: 10px;
    }

    ${ds.Button} {
      flex: 1;
    }
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    padding: 40px 77px;
    margin: 100px auto;

    ${NewsletterForm} {
      flex-direction: row;

      ${ds.Input} {
        margin-bottom: 0;
        margin-right: 10px;
      }
    }
  }
`

export const Main = styled.section`
  position: relative;
`
